module.exports = __webpack_public_path__ + "static/sent-163c5f9ea87347cc5bd6955d249a8b80.mp3";